import React from 'react';
const OmniBotGreetingMessage = ({ messageCount }) => {
    const newChatGreeting = (React.createElement("div", { className: "new-chat-greeting" },
        React.createElement("div", { className: "greeting-text" }, "Where would you like to start?")));
    const existingChatBanner = (React.createElement("div", { className: "existing-chat-greeting" },
        React.createElement("div", { className: "greeting-text" }, "Data Assistant")));
    const chatBanner = messageCount === 0 ? newChatGreeting : existingChatBanner;
    return React.createElement("div", { className: "chat-greeting-section" }, chatBanner);
};
export default OmniBotGreetingMessage;
//# sourceMappingURL=OmniBotGreetingMessage.js.map